import { appConfig, headerConfig, refineHeader } from "../../config";

export const citypasswordService = {
  addCityPassword,
  getCityPasswordList,
  deleteCityPassword,
  citypasswordStatus,
  getCityPasswordDetail,
  updateCityPassword,
};

function addCityPassword(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}citypassword/add`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getCityPasswordList(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}citypassword/list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function citypasswordStatus(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}citypassword/status`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function deleteCityPassword(citypasswordID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(
    `${appConfig.api.url}citypassword/delete/${citypasswordID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getCityPasswordDetail(citypasswordID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(
    `${appConfig.api.url}citypassword/detail/${citypasswordID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateCityPassword(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}citypassword/edit`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}


function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/citypasswordService.js